import React, { Component } from 'react'
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Table from '../../../../../facturotopia/table/Table';

class DocumentoImpuestosRetencionList extends Component {

  handleEdit = (item) => {
    this.handleDelete(item);

    this.props.onEdit(item);
  }

  handleDelete = (item) => {
    const newData = this.props.data.filter((value) => {
      return value.id !== item.id;
    });

    this.props.onChange(newData);
  }

  render() {
    const { data = [] } = this.props;

    return (
      <>
        <Table
          columns={ columns(this.handleEdit, this.handleDelete) }
          rowKey={ 'id' }
          data={ data }
        >
        </Table>
      </>
    )
  }
}

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
        </>
      );
    }
  },
  {
    key: 'BaseDR',
    title: 'Base',
    dataIndex: 'BaseDR',
  },
  {
    key: 'ImpuestoDR',
    title: 'Impuesto',
    dataIndex: 'ImpuestoDR',
  },
  {
    key: 'TipoFactorDR',
    title: 'Tipo Factor',
    dataIndex: 'TipoFactorDR',
  },
  {
    key: 'TasaOCuotaDR',
    title: 'Tasa O Cuota',
    dataIndex: 'TasaOCuotaDR',
  },
  {
    key: 'ImporteDR',
    title: 'Importe',
    dataIndex: 'ImporteDR',
  }
];

export default DocumentoImpuestosRetencionList;